export interface IArticle {
	title: string,
	desc: string,
	category: string,
	published: string,
	uri: string
}

export interface IValue {
	value: string
	selected: boolean
}

export interface ICategoryFilter {
	name: string
	identifier: string
	values: IValue[]
}

export interface ISort {
	name: string,
	field: string,
	isDescending: boolean,
	active: boolean
}

export interface ITranslations {
	lang: string,
	search: string,
	sort: string,
	articles: string,
	article: string,
	pagination: string,
	goTo: string,
	prev: string,
	next: string,
	pageLow: string,
	pageUpper: string,
	filter: string,
	date: string,
	dateFrom: string,
	dateTo: string,
	apply: string,
	reset: string,
	links: string
}

export interface IExtraLink {
	name?: string,
	uri?: string,
}

export interface IState {
	categories: string[],
	query: string,
	news: IArticle[],
	date: {
		start: string,
		end: string
	},
	endpoints: {
		search: string
	},
	page: number,
	total: number,
	count: number,
	pages: number,
	categoryFilter: ICategoryFilter[],
	sort: ISort[],
	title: string,
	description: string,
	translations: ITranslations,
	extraLinks: IExtraLink[]
}

const deafultState: IState = {
	categories: [],
	query: '',
	news: [],
	date: {
		start: '',
		end: ''
	},
	endpoints: {
		search: ''
	},
	page: 0,
	count: 0,
	pages: 0,
	total: 0,
	categoryFilter: [],
	sort: [],
	title: '',
	description: '',
	translations: {
		lang: '',
		search: '',
		sort: '',
		articles: '',
		article: '',
		pagination: '',
		goTo: '',
		prev: '',
		next: '',
		pageLow: '',
		pageUpper: '',
		filter: '',
		date: '',
		dateFrom: '',
		dateTo: '',
		apply: '',
		reset: '',
		links: ''
	},
	extraLinks: []
}

export default deafultState;
